
import {CLEANING_PLAN_STARTED} from "../../reducers/cleaningPlanReducer";


export const getCleaningPlanStarted = () =>{
    return {
        type: CLEANING_PLAN_STARTED,
        payload: {}
    }
}